import { render, staticRenderFns } from "./SingleChoiceQuestion.vue?vue&type=template&id=3e0428b3&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./SingleChoiceQuestion.vue?vue&type=script&lang=js&"
export * from "./SingleChoiceQuestion.vue?vue&type=script&lang=js&"
import style0 from "./SingleChoiceQuestion.vue?vue&type=style&index=0&id=3e0428b3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0428b3",
  null
  
)

export default component.exports